import Vue from 'vue'

const bus = new Vue();

export default  bus;
// 公共实例文件
// 主要用于非父子组件之间的传值问题



// WEBPACK FOOTER //
// ./src/components/bus.js